import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWomensHealthLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "currentColor",
	strokeWidth: 2,
	...props,
	children: [
		"\n      {/* Circle */}\n      ",
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 8,
			r: 6
		}),
		"\n      {/* Vertical Line */}\n      ",
		/* @__PURE__ */ _jsx("line", {
			x1: 12,
			y1: 14,
			x2: 12,
			y2: 24
		}),
		"\n      {/* Horizontal Line */}\n      ",
		/* @__PURE__ */ _jsx("line", {
			x1: 18,
			y1: 20,
			x2: 6,
			y2: 20
		})
	]
});
export default SvgWomensHealthLogo;
